/** Наборы журнала узла, которыми владеет модуль Libre */
export enum EnumLibreSet {
  NODES = 'libre.nodes',
}
